import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Gates XFA PDF form support: upload, edit and the `/xfa-document` session
 * window. Read from Flagsmith (OpenFeature), the same source the backend
 * gates its XFA endpoints on, so both sides flip together.
 * Kill switch / rollout — do NOT add useManualExposure. Default OFF.
 *
 * Lives in this standalone `.ts` module (not the `index.tsx` barrel) so the hook
 * does not add a `react-refresh/only-export-components` warning to the component
 * barrel. Import it directly from `@/features/flags/xfa-pdf-form-flag`.
 */
export const XFA_PDF_FORM_FLAG_KEY = 'release-growth-enable-xfa-pdf-form';

export const useIsXfaPdfFormEnabled = () =>
  useBooleanFlagValue(XFA_PDF_FORM_FLAG_KEY, false);
